import { render, staticRenderFns } from "./AlertMessageCenter.vue?vue&type=template&id=5d2401ef&scoped=true"
import script from "./AlertMessageCenter.vue?vue&type=script&lang=js"
export * from "./AlertMessageCenter.vue?vue&type=script&lang=js"
import style0 from "./AlertMessageCenter.vue?vue&type=style&index=0&id=5d2401ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2401ef",
  null
  
)

export default component.exports